export default __webpack_public_path__ + "static/media/newSopIcon_disabled.a32b21d1.svg";